const GA_ID = "G-WED3KDK526"

declare global {
	interface Window {
		gtag: (...args: unknown[]) => void
		dataLayer: unknown[]
	}
}

export function grantAnalyticsConsent() {
	if (typeof window.gtag !== "function") return
	window.gtag("consent", "update", {
		analytics_storage: "granted",
	})
}

export function revokeAnalyticsConsent() {
	if (typeof window.gtag !== "function") return
	window.gtag("consent", "update", {
		analytics_storage: "denied",
	})
}

export function gtagEvent(name: string, params?: Record<string, unknown>) {
	if (typeof window.gtag !== "function") return
	window.gtag("event", name, params)
}

export { GA_ID }
